import React from "react"
import styled from "styled-components"
import { device } from "../../utils/breakpoints"
import { anims, colors } from "../../utils/theme"

//Imagenes
import Icon from "../../images/list-icon.svg"

const Card = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;
  &::after {
    content: "";
    background: ${colors.pColor};
    width: 90%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    z-index: -1;
    transform: translateX(-50%);
  }
  & .header {
    width: 100%;
    background: ${colors.pLight};
    margin: 0 auto;
    padding: 2rem 2rem;
    display: block;
    z-index: 1;
    border-top: 7px solid ${colors.sColor};
    text-align: center;
    position: relative;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.13);
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 100%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      border-left: 30px solid transparent;
      border-right: 30px solid transparent;
      border-top: 30px solid ${colors.pLight};
    }
    &-title {
      font-weight: 800;
      font-style: italic;
      color: ${colors.sColor};
      margin: 0;
    }
    &-subtitle {
      font-weight: 800;
      font-style: italic;
      color: white;
    }
  }
  & .content {
    width: 90%;
    margin: 0 auto;
    padding: 3em 2em;
    & .price-before {
      font-size: 3em;
      color: #bdbdbd;
      font-weight: 800;
      font-style: italic;
      border-bottom: 3px solid rgba(0, 0, 0, 0.1);
      margin: 0 auto;
      padding: 1rem 0;
      position: relative;
      width: 100%;
      @media ${device.md} {
        width: 70%;
      }
      & span {
        font-size: 0.5em;
      }
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        height: 3px;
        width: 100%;
        background: ${colors.sColor};
        z-index: 1;
      }
      &:before {
        content: "ANTES";
        position: absolute;
        top: 25%;
        right: 10%;
        color: ${colors.sColor};
        z-index: 1;
        font-size: 0.25em;
      }
    }
    & .price-after {
      font-size: 4em;
      color: white;
      font-weight: 800;
      font-style: italic;
      padding: 1rem 0;
      position: relative;
      margin: 0 auto;
      width: 100%;
      @media ${device.md} {
        width: 70%;
      }
      & span {
        font-size: 0.5em;
      }
      &:before {
        content: "AHORA";
        position: absolute;
        top: 26%;
        right: 10%;
        color: ${colors.sColor};
        z-index: 1;
        font-size: 0.25em;
      }
    }
    & ul {
      list-style: none;
      padding-top: 1rem;
      @media ${device.md} {
        width: 80%;
        margin: 0 auto;
      }
      li {
        color: #dddddd;
        position: relative;
        padding-left: 2em;
        & strong {
          background: ${colors.sColor};
          color: ${colors.pColor};
          padding: 0 0.5em;
          border-radius: 4px;
        }
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          background-image: url(${Icon});
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          transform: translateY(-50%);
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  & .footer-buy {
    width: 100%;
    background: ${colors.pLight};
    margin: 0 auto;
    padding: 1.6rem 2rem;
    display: block;
    z-index: 1;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    & .button {
      border: 0;
      background: white;
      padding: 1.2em 3em 0.85em 3em;
      margin: 0 1em;
      ${anims.transition};
      & .type{
        font-size: .6em;
        color: gray;
      }
      &-paypal {
        background: white;
        box-shadow: 0 0 10px ${colors.sColor};
        line-height: 1em;
        &:hover {
          background: ${colors.sColor};
          box-shadow: 0 0 20px rgba(0, 0, 0, 0.43);
        }
      }
      &-mastercard {
        background: white;
        box-shadow: 0 0 10px ${colors.sColor};
        line-height: 1em;
        &:hover {
          background: ${colors.sColor};
          box-shadow: 0 0 20px rgba(0, 0, 0, 0.43);
        }
      }
      & span {
        font-weight: 800;
        font-size: 1.6em;
        color: ${colors.pColor};
      }
    }
  }
`

function ShopCard() {
  return (
    <Card>
      <div className="header">
        <h2 className="header-title">PARTICIPA</h2>
        <h3 className="header-subtitle">INVIERTE</h3>
      </div>
      <div className="content">
        <h4 className="price-before text-center">
          $149<span>Usd.</span>
        </h4>
        <h5 className="price-after text-center">
          $69<span>Usd.</span>
        </h5>
        <ul>
          <li>ACCESO A CLASES EN VIDEO</li>
          <li>
            <strong>FEEDBACK EN VIVO</strong>
          </li>
          <li>MATERIAL DEL AYUDA</li>
          <li>ACCESO A DISCORD</li>
        </ul>
      </div>
      <div className="footer-buy">
        <button className="button button-paypal">
          <span className="button-price">$69 USD</span> <br />
          <span className="type">PAYPAL</span>
        </button>
        <button className="button button-mastercard">
          <span className="button-price">$69 USD</span><br />
          <span className="type"> TARJETA DE CRÉDITO</span>
        </button>
      </div>
    </Card>
  )
}

export default ShopCard
